import * as _ from 'lodash';
import { IContact } from '@nkr/models/index';
import { FormEvent, useEffect, useState } from 'react';
import { Alert, Button, Col, ControlLabel, Form, FormControl, FormGroup, Modal } from 'react-bootstrap'
import usePrevious from '@nkr/services/use-previous';

interface IProps {
    show: boolean,
    alias: string,
    contactList: IContact[],
    onSubmit: (contactId: number) => void,
    onCancel: () => void
}

const EmailRecipientDetailsModal = (props: IProps) => {
    const [selectedContact, setSelectedContact] = useState(0);
    const [valid, setValid] = useState(true);
    const [dirty, setDirty] = useState(true);

    const previousShow = usePrevious(props.show);

    useEffect(() => {
        if (previousShow == false && props.show == true) {
            setSelectedContact(0);
            setValid(true);
            setDirty(false);

        }
    }, [props.show]);

    const handleSubmit = () => {
        let newValid = selectedContact > 0;

        setValid(newValid);
        setDirty(true);

        if (newValid) {
            props.onSubmit(selectedContact);
        }
    };

    let sortedList = _.sortBy(props.contactList, x => x.fullName.trim());

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>Email Recipient Details</Modal.Header>
            <Modal.Body>
                {dirty && !valid && (
                    <Alert bsStyle='danger' bsSize='sm'>
                        The items in red are required to continue...
                    </Alert>
                )}

                {props.alias != '' && (
                    <blockquote>Alias: {props.alias}</blockquote>
                )}

                <Form horizontal>
                    <FormGroup validationState={dirty && valid == false ? 'error' : null}>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Email Address:</Col>
                        <Col xs={12} lg={8}>
                            <FormControl
                                componentClass='select'
                                name='emailAddress'
                                value={selectedContact}
                                onChange={(e: FormEvent<FormControl & HTMLInputElement>) => setSelectedContact(parseInt(e.currentTarget.value))}
                            >
                                <option value={0}>- Select -</option>
                                {sortedList.map(contact =>
                                    <option key={'contact-' + contact.id} value={contact.id}>{contact.fullName}</option>
                                )}
                            </FormControl>
                        </Col>
                    </FormGroup>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleSubmit}>Send</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default EmailRecipientDetailsModal;